import withWidgetHeaderAndFooter from './withWidgetHeaderAndFooter';
export default withWidgetHeaderAndFooter;



// WEBPACK FOOTER //
// ./src/components/withWidgetHeaderAndFooter/index.js